import { gql, TypedDocumentNode } from '@apollo/client'
import { getApolloClient } from '@vivaldis/common'
import { userQuery } from '@vivaldis/session'
import type {
  AcceptTermsAndConditionsMutation,
  AcceptTermsAndConditionsMutationVariables
} from './__generated__/AcceptTermsAndConditionsMutation'

export const mutation: TypedDocumentNode<
  AcceptTermsAndConditionsMutation,
  AcceptTermsAndConditionsMutationVariables
> = gql`
  mutation AcceptTermsAndConditionsMutation(
    $input: AcceptTermsAndConditionsInput!
  ) {
    acceptTermsAndConditions(input: $input) {
      status
    }
  }
`

export const acceptTermsAndConditionsMutation = () => {
  const apolloClient = getApolloClient()
  return apolloClient.mutate({
    mutation,
    variables: { input: {} },
    refetchQueries: [userQuery],
    awaitRefetchQueries: true
  })
}
